const COMPANY_COLORS = ["#7E57FF", "#FF7A45", "#11C7B0", "#16C350", "#FF3F47"];

export const getCompanyAvatarColor = (companyId: string) => {
  const index =
    companyId.split("").reduce((acc, ch) => acc + ch.charCodeAt(0), 0) %
    COMPANY_COLORS.length;
  return COMPANY_COLORS[index];
};

export const getCompanyInitials = (name: string) =>
  name
    .split(" ")
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
